<template>
    <div class="wrap">
        <div class="bannerImg">
            <img :src="bannerUrl" height="500" width="1907" />
        </div>
        <div class="display_between">
            <div v-show="indregist" class="menuBlock" @click="regclick(0)">
                <h3>{{ perRegistName }}</h3>
            </div>
            <div v-show="hotel" class="menuBlock" style="background-color: #484b80" @click="regclick(0)">
                <h3>{{ HotelReservationName }}</h3>
            </div>
            <div v-show="teamregist" class="menuBlock" @click="regclick(1)">
                <h3>{{ teamRegistName }}</h3>
            </div>
            <div
                v-show="mtg_LiveType != 0"
                class="menuBlock"
                style="background-color: #484b80"
                @click="mtg_LiveType == 1 ? (mtg_ChannelType == 1 ? liveclk() : livelistclk()) : mtg_ChannelType == 1 ? Huodeliveclk() : livelistclk()"
            >
                <h3>微直播</h3>
            </div>
        </div>

        <!-- 目睹 -->
        <!-- <div v-if="mtg_LiveType ==1">
      <div v-if="mtg_ChannelType ==1">
        <div v-show="Live!=null && Live.name!=null"
             class="liveBlock EC_width"
             style=" margin-top: 10px;">

          <div class="liveBlockcontent"
               @click="liveclk()">
            <div class="titleBan">
              {{Live.name}}
            </div>
            <div class="liveTextBox">
              <p>{{Live.live_status==1?'正在直播':'没有直播'}} </p>
              <p>{{ (liveStartTime !="")?formatTime(liveStartTime, 'yyyy-MM-dd HH:mm:SS'):'' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="liveBlock EC_width"
             style=" margin-top: 10px;">
          <div class="liveBlockcontent"
               @click="livelistclk()">
            <div class="titleBan">
              {{meeitngInfo.mtg_LiveName}}
            </div>
          </div>
        </div>
      </div>

    </div> -->
        <!-- 获得场景 -->
        <!-- <div v-else-if="mtg_LiveType ==2">
      <div v-if="mtg_ChannelType ==1">
        <div v-show="huodeLive!=null "
             class="liveBlock EC_width"
             style=" margin-top: 10px;">

          <div class="liveBlockcontent"
               @click="Huodeliveclk()">
            <div class="titleBan">
              {{huodeLive.name}}
            </div>
            <div class="liveTextBox">
              <p>{{ (huodeLive.liveStartTime !="")?formatTime(huodeLive.liveStartTime, 'yyyy-MM-dd HH:mm:SS'):'' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="liveBlock EC_width"
             style=" margin-top: 10px;">
          <div class="liveBlockcontent"
               @click="livelistclk()">
            <div class="titleBan">
              {{meeitngInfo.mtg_LiveName}}
            </div>
          </div>
        </div>
      </div>
    </div> -->

        <div class="display_between_nocenter EC_width marginTop40">
            <div class="leftBan" v-if="focusMap.length > 0">
                <swiper :options="swiperOption" ref="mySwiper3">
                    <swiper-slide v-for="(item, index) in focusMap" :key="index">
                        <img :src="item.picturesUrl" width="100%" height="284" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div class="flex1" style="position: relative" v-if="mtgInfo.name">
                <div class="titleBan">
                    {{ mtgInfo.name }}
                </div>

                <div class="textBan point" v-html="mtgInfo.contents" @click="toDetail(mtgInfo, 1)"></div>
                <span class="dian" @click="toDetail(mtgInfo, 1)">...more</span>
                <div class="shadow"></div>
            </div>
        </div>
        <div class="grayBlock" v-if="lecturer.length > 0">
            <div class="blockTitle">
                <!-- 特邀讲者 -->
                {{ lecturerName }}
            </div>
            <div class="positionBtn EC_width">
                <swiper :options="swiperOption2" ref="mySwiper">
                    <swiper-slide v-for="(item, index) in lecturer" :key="index" style="margin-top: 10px">
                        <a href="javascript:;" class="mediaImg">
                            <img :src="item.picturesUrl" style="width: 120px; height: 156px" />
                            <div>
                                {{ item.columnName }}
                            </div>
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="prevbutton2 el-icon-arrow-left"></div>
                <div class="nextbutton2 el-icon-arrow-right"></div>
            </div>
        </div>
        <div class="dateBlock" v-if="impTime == true">
            <div class="EC_width display_between display_center_ud height_100">
                <!-- <div class="flex1 text_center" v-for="(item,index) in apiData.opre" :key="index">
          <p class="dateTitle">{{item.title}}</p>
          <p class="dateText">{{item.date}}</p>
        </div> -->
                <div class="flex1 text_center">
                    <p class="dateTitle">会议时间</p>
                    <p class="dateText">{{ formatTime(meeitngInfo.mtg_StartTime, 'YYYY/MM/DD') }}-{{ formatTime(meeitngInfo.mtg_EndTime, 'YYYY/MM/DD').substr(8, 9) }}</p>
                </div>
                <div class="flex1 text_center">
                    <p class="dateTitle">报名截止日期</p>
                    <p class="dateText">{{ formatTime(deadline, 'YYYY/MM/DD') }}</p>
                </div>
                <div class="flex1 text_center">
                    <p class="dateTitle">现场报道时间</p>
                    <p class="dateText">{{ formatTime(meeitngInfo.mtg_Req_EndTime, 'YYYY/MM/DD') }}</p>
                </div>
            </div>
        </div>
        <div class="normalBlock" v-show="organization != '' && organization != null">
            <div class="blockTitle">
                {{ organizatName }}
                <!-- 组织机构 -->
            </div>
            <p v-html="organization"></p>
        </div>
        <div class="grayBlock" v-if="dynamic.length > 0">
            <div class="blockTitle">
                {{ dynamicName }}
                <!-- 会议动态 -->
            </div>
            <div class="display_between EC_width">
                <div v-for="(item, index) in dynamic" :key="index" class="point" @click="toDetail(item, 2)">
                    <img :src="item.picturesUrl" width="370" />
                    <p class="fontsize16 fontBold marginTop20">{{ item.columnName }}</p>
                    <span class="fontsize16 fontBold marginTop10" style="color: rgb(98, 104, 196)">Read More</span>
                </div>
            </div>
        </div>

        <div class="grayBlock" v-show="exhibitors.length > 0">
            <div class="blockTitle">
                {{ exhibitorsName }}
                <!-- 参展企业 -->
            </div>
            <div class="positionBtn EC_width">
                <swiper :options="swiperOption3" ref="mySwiper2">
                    <swiper-slide v-for="(item, index) in exhibitors" :key="index">
                        <a href="javascript:;" class="mediaImg">
                            <img :src="item.picturesUrl" style="width: 300px; height: 200px" />
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="prevbutton3">&lt;</div>
                <div class="nextbutton3">&gt;</div>
            </div>
        </div>
        <div class="normalBlock" v-show="mtgtraffic == true">
            <div class="blockTitle">
                <!-- 交通地图 -->
                {{ mtgtrafficName }}
            </div>
            <div class="EC_width">
                <!-- <img :src="apiData.map" alt="" width="100%"> -->
                <!-- @ready="handler" -->
                <baidu-map class="map" @ready="ready" :center="center" :zoom="15">
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                    <bm-marker :position="center" :dragging="true" @click="infoWindowOpen">
                        <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" style="font-size: 13px">地址：{{ markerPoint }}</bm-info-window>
                    </bm-marker>
                </baidu-map>
            </div>
        </div>
        <div class="contentFooterf">
            <div class="contentFooter" v-show="links.length > 0">
                <vue-seamless-scroll :data="links" :class-option="classOption">
                    <div class="display_center_ud cfbox" :style="'width:' + fcwidth">
                        <img class="fbox" v-for="(item, index) in links" :key="index" :src="item.picturesUrl" width="190" height="50" />
                    </div>
                </vue-seamless-scroll>
            </div>
        </div>
        <div class="fuchuang" v-show="isfuchuang && fuchuang">
            <a v-if="fuchuang != null" :href="fuchuang.hyperlinks" target="_blank">
                <img :src="fuchuang.picturesUrl" alt="" />
            </a>
            <div class="guanbi" @click="isfuchuang = false">
                <img src="../../assets/img/icon/failure.png" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
import lodash from 'lodash';
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
    name: 'meetingpc',
    components: {
        vueSeamlessScroll,
    },
    data() {
        return {
            center: { lng: 0, lat: 0 },
            Bmap: null, //百度地图核心类
            map: null, //百度地图实例
            markerPoint: '',
            apiData: {},
            con: '为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。为进一步加强我国医疗机构儿童临床用药管理，促进临床合理用药，保障医疗质量和医疗安全，经研究，我会决定于2020年8月28日-30日举办2020年儿童合理用药大会。',
            show: true,
            swiperOption: {
                loop: true, // 循环模式选项
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                },
            },
            swiperOption2: {
                slidesPerView: 5,
                slidesPerGroup: 5,
                slidesPerColumn: 2,
                slidesPerColumnFill: 'column',
                spaceBetween: 10,
                // mousewheel: true,
                freeMode: true,
                parallax: true,
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.nextbutton2',
                    prevEl: '.prevbutton2',
                    disabledClass: 'my-button-disabled',
                    clickable: true,
                },
            },
            swiperOption3: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 10,
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.nextbutton3',
                    prevEl: '.prevbutton3',
                    disabledClass: 'my-button-disabled',
                },
            },
            meeitngInfo: {},
            webSiteColumnlist: [],
            bannerUrl: '',
            indregist: false,
            hotel: false,
            teamregist: false,
            mtgtraffic: false,
            focusMap: [], //首页焦点图
            mtgInfo: { name: '', contents: '' },
            lecturer: [], //特邀讲者
            organization: '', //组织机构
            dynamic: [], //會議動態
            exhibitors: [], //參展企業
            links: [], //友情链接
            mtgId: 0,
            perRegistName: '参会注册',
            HotelReservationName: '酒店预订',
            teamRegistName: '团队注册',
            organizatName: '组织机构',
            dynamicName: '会议动态',
            exhibitorsName: '参展企业',
            mtgtrafficName: '交通地图',
            isDebug: false,
            fuchuang: '',
            isfuchuang: true,
            impTime: false,
            Live: {},
            live_img: '',
            liveStartTime: '',
            huodeLive: {},
            mtg_ChannelType: 1, //1 直播,2直播列表
            mtg_LiveType: 0, //1目睹 2获得场景
            AuthorId: '',
            qid: 0,
            deadline: '',
            classOption: {
                limitMoveNum: 6,
                direction: 2,
            },
            fcwidth: '',
            habitLogin: false,
        };
    },
    created() {
        // this.getData();
        if (this.$route.query.mid != '') {
            this.mtgId = this.$route.query.mid;
        }
        if (this.isMobile()) {
            this.$router.push({
                path: '/meetingMobile',
                query: {
                    mid: this.mtgId,
                },
            });
        } else {
            this.getWebSiteConfigList();
            this.GetRegistSystemConfig();
        }
        // this.getMeetingInfo();
    },
    methods: {
        //百度地图初始化事件
        ready({ BMap, map }) {
            this.Bmap = BMap; //百度BMap核心类
            this.map = map; //地图实例
            this.getMeetingInfo();
            var marker = new BMap.Marker(this.center); //将点转化成标注点
            marker.setOffset(new BMap.Size(20, -1)); //画布偏移
        },
        formatTime(datatime, timeformat) {
            return format(datatime, timeformat);
        },
        infoWindowClose() {
            this.show = false;
        },
        infoWindowOpen() {
            this.show = true;
        },
        getData() {
            var that = this;
            fetch('/data.json')
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    that.apiData = data.meetinghome;
                    var usedata = data.meetinghome.dynamic2;

                    that.dynamic = lodash.chunk(usedata, 2);
                });
        },
        getWebSiteConfigList() {
            let _this = this;
            this.httphelper
                .post('/api/WebSiteConfigApi/GetWebSiteConfigList', {
                    mtg_Id: parseInt(_this.mtgId),
                    type: 1,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        //网站栏目信息列表
                        _this.webSiteColumnlist = res.data.data.webSiteColumnlist;
                        _this.webSiteColumnlist.forEach(item => {
                            if (item.fromItemID == 2) {
                                //重要时间
                                _this.impTime = true;
                            }
                            if (item.fromItemID == 3) {
                                //头部banner
                                _this.bannerUrl = item.picturesUrl;
                            }
                            if (item.fromItemID == 4) {
                                //会议信息
                                _this.mtgInfo = item;
                                _this.mtgInfo.name = item.columnName;
                                _this.mtgInfo.contents = item.contents;
                            } else if (item.fromItemID == 5) {
                                //组织机构
                                _this.organizatName = item.columnName;
                                _this.organization = item.contents;
                            } else if (item.fromItemID == 6) {
                                //首页焦点图
                                _this.focusMap = _this.sortKey(item.detaillist, 'sort');
                            }
                            if (item.fromItemID == 7) {
                                //会议动态
                                _this.dynamicName = item.columnName;
                                _this.dynamic = _this.sortKey(item.detaillist, 'sort');
                            } else if (item.fromItemID == 8) {
                                //特邀讲者
                                _this.lecturerName = item.columnName;
                                _this.lecturer = _this.sortKey(item.detaillist, 'sort');
                                _this.swiperOption2.slidesPerColumn = _this.lecturer.length > 10 ? 2 : 1;
                            } else if (item.fromItemID == 9) {
                                _this.perRegistName = item.columnName;
                                //个人注册
                                //个人注册按钮
                                _this.indregist = true;
                            } else if (item.fromItemID == 10) {
                                //酒店预订
                                //酒店预订按钮
                                _this.HotelReservationName = item.columnName;
                                _this.hotel = true;
                            } else if (item.fromItemID == 11) {
                                //团队注册
                                //团队注册
                                _this.teamRegistName = item.columnName;
                                _this.teamregist = true;
                            }
                            if (item.fromItemID == 12) {
                                //会场交通
                                _this.mtgtrafficName = item.columnName;
                                _this.mtgtraffic = true;
                            } else if (item.fromItemID == 14) {
                                //参展企业
                                _this.exhibitorsName = item.columnName;
                                _this.exhibitors = _this.sortKey(item.detaillist, 'sort');
                            } else if (item.fromItemID == 13) {
                                //友情链接
                                //友情链接
                                _this.links = _this.sortKey(item.detaillist, 'sort');
                                _this.fcwidth = 240 * _this.links.length + 'px';
                            } else if (item.fromItemID == 15) {
                                _this.fuchuang = item.detaillist[0];
                            }
                        });
                    }
                });
        },
        getMeetingInfo() {
            let _this = this;
            _this.Live = null;
            _this.huodeLive = null;
            this.httphelper.get('/api/MeetingApi/GetMeetingInfoByID?mtgId=' + parseInt(this.mtgId)).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    //给地图赋值
                    _this.markerPoint = data.mtg_Adress;
                    _this.meeitngInfo = data;
                    _this.habitLogin = data.habitLogin;
                    setTimeout(function () {
                        _this.center = { lng: data.mtg_lng, lat: data.mtg_Lat };
                    }, 1000 * 0.1); //时间设置为0也是可以
                    // this.$route.meta.title = _this.meeitngInfo.mtg_Name;
                    // this.$router.replace({
                    //   query: {
                    //     mid: this.mtgId,
                    //     temp: Date.now()
                    //   }
                    // });
                    document.title = _this.meeitngInfo.mtg_Name;
                    this.mtg_LiveType = data.mtg_LiveType;
                    this.mtg_ChannelType = data.mtg_ChannelType;
                    if (data.mtg_LiveType == 1) {
                        //判断是直播,还是直播列表
                        if (data.mtg_ChannelType == 1) {
                            _this.httphelper
                                .post('/api/LiveApi/GetMuduLiveById', {
                                    Id: data.mtg_LiveId,
                                })
                                .then(res => {
                                    if (res.data.code == 200) {
                                        _this.Live = res.data.data;

                                        _this.live_img = res.data.data.live_img;
                                        _this.liveStartTime = res.data.data.start_time;
                                    }
                                });
                        }
                    } else if (data.mtg_LiveType == 2) {
                        //获得场景
                        if (data.mtg_ChannelType == 1) {
                            _this.httphelper
                                .post('/api/LiveApi/GetHuodeLiveById', {
                                    roomid: data.mtg_LiveId,
                                })
                                .then(res => {
                                    if (res.data.result == 'OK') {
                                        _this.huodeLive = res.data.room;
                                    }
                                });
                        }
                    }
                }
            });
        },
        // 判断是手机还是pc
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        },
        regclick(cpg) {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.Mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            if (cpg > 0) {
                                if (!this.isDebug) {
                                    // window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg, '_blank');
                                    window.open(this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId + '&cgp=' + cpg, '_blank');
                                } else {
                                    // window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg, '_blank');
                                    window.open(this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId + '&cgp=' + cpg, '_blank');
                                }
                            } else {
                                if (!this.isDebug) {
                                    // window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
                                    window.open(this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId, '_blank');
                                } else {
                                    // window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
                                    window.open(this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId, '_blank');
                                }
                            }
                        } else {
                            let routername = 'login';
                            if (this.habitLogin) {
                                routername = 'userlogin';
                            }
                            this.$router.push({ name: routername, query: { callback: decodeURIComponent(window.location.href) } });
                            // this.$router.push({ name: 'login', query: { callback: decodeURIComponent(window.location.href) } });
                        }
                    });
            } else {
                var hrefurl = '';
                if (cpg == 0) {
                    if (!this.isDebug) {
                        // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                        hrefurl = this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId;
                    } else {
                        // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                        hrefurl = this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId;
                    }
                } else {
                    if (!this.isDebug) {
                        // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                        hrefurl = this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                    } else {
                        // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                        hrefurl = this.httphelper.IspcDebugH5GP519() + '/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                    }
                }
                let routername = 'login';
                if (this.habitLogin) {
                    routername = 'userlogin';
                }
                this.$router.push({ name: routername, query: { callback: decodeURIComponent(window.location.href) } });
                // this.$router.push({ name: 'login', query: { callback: decodeURIComponent(hrefurl) } });
            }
        },
        Defconfirm() {
            this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$router.push({ name: 'userInfor' });
            });
        },
        toDetail(item, type) {
            let _target = '_self';
            if (type == 1) {
                const { href } = this.$router.resolve({
                    path: 'meetingDetail',
                    query: { cid: item.id, id: 0, mid: this.mtgId, type: 2 },
                });
                window.open(href, _target);
            } else {
                const { href } = this.$router.resolve({
                    path: 'meetingDetail',
                    query: { cid: item.c_Id, id: item.id, mid: this.mtgId, type: 2 },
                });
                window.open(href, _target);
            }
        },
        sortKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        },
        //直播点击事件
        liveclk() {
            //1.先判断是否登录
            //2.判断是否有调查问卷
            //3.跳转
            if (this.Live != null) {
                if (this.Live.page != null || this.Live.page.start_time != '') {
                    if (this.$cookies.isKey('token_chinagp')) {
                        var _tokenkey = this.$cookies.get('token_chinagp');
                        this.httphelper
                            .post('/api/LoginApi/CheckToken', {
                                tokenKey: _tokenkey,
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$cookies.set('token_chinagp', _tokenkey);
                                    this.AuthorId = res.data.data.id;
                                    this.toLive(this.Live.id, 1, _tokenkey);
                                } else {
                                    this.$alert('请先登录', '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {
                                            let callback = encodeURIComponent(window.location.href);
                                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                                        },
                                    });
                                }
                            });
                    } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                        this.httphelper
                            .post('/api/LoginApi/CheckToken', {
                                tokenKey: this.$route.query.tokenkey,
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                                    this.AuthorId = res.data.data.id;
                                    this.toLive(this.Live.id, 1, this.$route.query.tokenkey);
                                } else {
                                    this.$alert('请先登录', '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {
                                            let callback = encodeURIComponent(window.location.href);
                                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                                        },
                                    });
                                }
                            });
                    } else {
                        this.$alert('请先登录', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                let callback = encodeURIComponent(window.location.href);
                                window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                            },
                        });
                    }
                } else {
                    //直播开始时间未设置
                    this.$message({
                        message: '直播开始时间未设置',
                        type: 'warning',
                    });
                }
            }
        },
        Huodeliveclk() {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$cookies.set('token_chinagp', _tokenkey);
                            this.AuthorId = res.data.data.id;
                            this.toLive(this.huodeLive.id, 2, _tokenkey);
                        } else {
                            this.$alert('请先登录', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    let callback = encodeURIComponent(window.location.href);
                                    window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                                },
                            });
                        }
                    });
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                            this.AuthorId = res.data.data.id;
                            this.toLive(this.huodeLive.id, 2, this.$route.query.tokenkey);
                        } else {
                            this.$alert('请先登录', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    let callback = encodeURIComponent(window.location.href);
                                    window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                                },
                            });
                        }
                    });
            } else {
                this.$alert('请先登录', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        let callback = encodeURIComponent(window.location.href);
                        window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                    },
                });
            }
        },
        //直播列表跳转
        livelistclk() {
            const { href } = this.$router.resolve({
                path: '/channelList?',
                query: {
                    Id: this.meeitngInfo.mtg_LiveId,
                    type: this.mtg_LiveType,
                    mid: this.mtgId,
                },
            });
            window.open(href, '_blank');
        },
        toLive(id, liveType, tokenkey) {
            //验证是否需要报名
            this.httphelper
                .post('/api/LiveApi/GetLiveRegistSet', {
                    LiveId: id.toString(),
                    LiveType: parseInt(liveType),
                    MtgId: parseInt(this.mtgId),
                    UserId: parseInt(this.AuthorId),
                })
                .then(res => {
                    if (res.data.code != 200) {
                        //请先报名
                        this.$alert('请先报名会议在观看', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.regcheck();
                            },
                        });
                    } else {
                        //已经报名了，跳转直播页面
                        // if (this.mtgId > 0) {
                        this.CheckIsQuestionnaire(id, liveType, tokenkey);
                        // } else {
                        //   if (liveType == 1) {
                        //     const { href } = this.$router.resolve({
                        //       path: '/muduLive?',
                        //       query: {
                        //         id: id,
                        //         mid: this.mtgId,
                        //         tokenkey: tokenkey
                        //       }
                        //     });
                        //     window.open(href, '_blank');
                        //   } else if (liveType == 2) {
                        //     const { href } = this.$router.resolve({
                        //       path: '/huodeLive?',
                        //       query: {
                        //         id: id,
                        //         mid: this.mtgId,
                        //         tokenkey: tokenkey
                        //       }
                        //     });
                        //     window.open(href, '_blank');
                        //   }
                        // }
                    }
                });
        },
        //验证是否需要问卷
        CheckIsQuestionnaire(id, liveType, tokenkey) {
            this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + id + '&livetype=' + parseInt(liveType)).then(res => {
                if (res.code == 200) {
                    if (liveType == 1) {
                        const { href } = this.$router.resolve({
                            path: '/muduLive?',
                            query: {
                                id: id,
                                mid: this.mtgId,
                                tokenkey: tokenkey,
                            },
                        });
                        window.open(href, '_blank');
                    } else if (liveType == 2) {
                        const { href } = this.$router.resolve({
                            path: '/huodeLive?',
                            query: {
                                id: id,
                                mid: this.mtgId,
                                tokenkey: tokenkey,
                            },
                        });
                        window.open(href, '_blank');
                    }
                } else {
                    if (res.code == 20) {
                        this.qid = res.data.id;
                        //验证当前用户是否报名
                        this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedback?qid=' + res.data.id + '&userid=' + this.AuthorId).then(res => {
                            if (res.code == 200) {
                                //继续观看
                                if (liveType == 1) {
                                    const { href } = this.$router.resolve({
                                        path: '/muduLive?',
                                        query: {
                                            id: id,
                                            mid: this.mtgId,
                                            tokenkey: tokenkey,
                                        },
                                    });
                                    window.open(href, '_blank');
                                } else if (liveType == 2) {
                                    const { href } = this.$router.resolve({
                                        path: '/huodeLive?',
                                        query: {
                                            id: id,
                                            mid: this.mtgId,
                                            tokenkey: tokenkey,
                                        },
                                    });
                                    window.open(href, '_blank');
                                }
                            } else {
                                //跳转调查问卷
                                this.$alert('请先填写调查问题', '提示', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        let callback = encodeURIComponent(window.location.href);
                                        this.$router.push({
                                            path: '/question?',
                                            query: {
                                                qid: this.qid,
                                                callback: callback,
                                            },
                                        });
                                    },
                                });
                            }
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning',
                        });
                    }
                }
            });
        },
        //判断是否报名，否跳转会议报名
        regcheck() {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
                        } else {
                            let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                        }
                    });
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
                        } else {
                            let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                        }
                    });
            } else {
                var hrefurl = '';
                hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                let callback = encodeURIComponent(hrefurl);
                window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
            }
        },
        GetRegistSystemConfig() {
            let _this = this;
            _this.httphelper.get('/api/MeetingApi/GetRegistSystemConfigInfo?Mtgid=' + parseInt(_this.mtgId)).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    if (data != null) _this.deadline = data.deadline;
                }
            });
        },
    },
};
</script>

<style scoped>
.map {
    width: 1240px;
    height: 477px;
}

.bannerImg img {
    width: 100%;
    height: 100%;
}

.menuBlock {
    background-color: rgb(98, 104, 196);
    display: block;
    text-align: center;
    padding: 30px 18px;
    color: #fff;
    cursor: pointer;
    flex: 1;
}

.leftBan {
    width: 620px;
    margin-right: 20px;
}

/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1300px;
}

/* 首页文字轮播 */
.bulletWrite {
    margin-right: 6px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #6c9ca3;
    border-radius: 50%;
}

.bulletWriteActive {
    width: 24px;
    height: 10px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
}

.my-bullet-active {
    background: #ff6600;
    opacity: 1;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}

.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2,
.nextbutton3,
.prevbutton3 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton,
.nextbutton2,
.nextbutton3 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2,
.prevbutton3 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.titleBan {
    margin-bottom: 20px;
    line-height: initial;
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
}

.textBan {
    line-height: 2em;
    cursor: pointer;
    height: 224px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}

.shadow {
    width: calc(100% - 80px);
    height: 15px;
    position: absolute;
    bottom: 0px;
    right: 90px;
    box-shadow: 0 -17px 10px -8px #fff inset;
}

.dian {
    position: absolute;
    background-color: #fff;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
    padding: 5px 10px;
    box-shadow: 0px -15px 15px 0px #fff;
}

.point {
    cursor: pointer;
}

.grayBlock {
    background: #f6f6f6;
    padding: 40px 0;
}

.normalBlock {
    padding: 40px 0;
    background: #fff;
}

.blockTitle {
    font-size: 30px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
}

.dateBlock {
    height: 234px;
    background-color: rgba(98, 104, 196, 0.8);
}

.dateTitle {
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    line-height: 60px;
    position: relative;
}

.dateTitle::after {
    content: '';
    display: block;
    position: absolute;
    width: 40px;
    height: 3px;
    left: 50%;
    margin-left: -20px;
    background-color: rgba(255, 255, 255, 0.3);
}

.dateText {
    color: #fff;
    font-weight: bold;
    font-size: 26px;
    letter-spacing: 2px;
    margin-top: 10px;
}

.ztitle,
.ztext {
    text-align: center;
}

.ztitle {
    color: #337fe5;
    font-family: 'Microsoft YaHei';
    line-height: 2;
    font-size: 16px;
    font-weight: bold;
}

.ztext {
    color: #333333;
    font-family: 'Microsoft YaHei';
    line-height: 2;
    font-size: 16px;
}

.swiper-slide {
    text-align: center;
}

.fuchuang {
    position: fixed;
    top: 200px;
    right: 20px;
    width: 300px;
    height: 200px;
    z-index: 999;
    background-color: #fff;
}

.fuchuang .guanbi {
    position: absolute;
    left: -20px;
    top: -13px;
}

.fuchuang .guanbi img {
    width: 20px;
    height: 20px;
}

.fuchuang a img {
    width: 300px;
    height: 200px;
}

.liveBlock {
    width: 1240px;
    height: 150px;
}

.liveBlockImg {
    width: 620px;
    margin-right: 20px;
}

.liveBlockcontent {
    width: 1240px;
    height: 150px;
    float: left;
    padding: 25px 0 0 30px;
    margin: 20px 0 0 0;
    box-sizing: border-box;
    background: #edeef2;
    cursor: pointer;
    border-radius: 20px;
    box-shadow: 0px 4px 8px 0px rgba(66, 66, 66, 0.075);
}

.liveTextBox {
    height: 60px;
    line-height: 30px;
}

.contentFooterf {
    width: 100%;
    background-color: #eee;
}

.contentFooter {
    width: 1240px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 20px;
    box-sizing: border-box;
}

.cfbox {
    /* width: 1240px; */
    display: flex;
    /* overflow: hidden; */
    margin-bottom: 20px;
}

.fbox {
    width: 190px;
    margin-right: 50px;
}
</style>
